/* eslint-disable no-nested-ternary */
import * as vp from 'vopay';
import { FunctionComponent } from 'react';
import Lottie from 'lottie-react';
import { useTranslation } from 'react-i18next';
import styles from './Messages.module.scss';
import paymentAnimation from '../../../../../component-library/src/components/DataDisplay/Lottie/Paylink_Received.json';
import { useToken } from '../../providers/Token.provider';

const { Box, Title } = vp;

type FC = FunctionComponent;

const Success: FC = () => {
  const lottieStyle = {
    width: 250,
    height: 250,
  };
  const { isSetByBrowser } = useToken();
  const { t } = useTranslation('translations', { keyPrefix: 'SuccessPage' });
  return (
    <div className={styles.lastMSGContainer}>
      <Box flx="col" height="auto" ai="center">
        <div className={styles.svgContainer}>
          <Lottie animationData={paymentAnimation} loop style={lottieStyle} height={50} />
        </div>
        <Box pb={isSetByBrowser ? 'md' : 'lg'}>
          <div className={styles.setup}>
            <Title title={<>{`${t('javascriptMessageTitle')}`}</>} size={isSetByBrowser ? 'md' : 'lg'} bold center />
          </div>
        </Box>

        <Box pb="lg">
          <p className={styles.SuccessDescription}>{`${t('javascriptMessageSubline')}`}</p>
        </Box>
      </Box>
    </div>
  );
};

export default Success;
